import i18n from "@/configs/i18n.js";

function getGeralMensagens() {
  const pack = i18n.messages[i18n.locale];
  if (!pack || !pack.interface || !pack.interface.geral) {
    return { validacao: {}, erro: {} };
  }
  return pack.interface.geral;
}

function aplicarWrapMensagemNotify(h, payload) {
  if (!h || !payload || payload.dangerouslyUseHTMLString) {
    return payload;
  }
  const texto = payload.message;
  if (typeof texto !== "string") {
    return payload;
  }
  const { dangerouslyUseHTMLString: _omit, ...resto } = payload;
  return {
    ...resto,
    message: h(
      "i",
      {
        style: {
          color: "#295661",
          display: "block",
          fontStyle: "normal",
          textAlign: "left"
        }
      },
      texto
    )
  };
}

export function buildValidationNotifyPayload(h, err) {
  const geral = getGeralMensagens();
  const fe = err.fieldErrors;
  const keys = fe ? Object.keys(fe) : [];
  const msg = err.message || "";
  let message = msg;
  let dangerouslyUseHTMLString = false;

  if (fe && keys.length > 1) {
    message = geral.validacao.resumoVarios;
  } else if (fe && keys.length === 1) {
    message = fe[keys[0]];
  } else if (typeof msg === "string" && msg.indexOf("\n") !== -1) {
    message = msg
      .split("\n")
      .map(s => s.trim())
      .filter(Boolean)
      .join("<br/>");
    dangerouslyUseHTMLString = true;
  }

  return aplicarWrapMensagemNotify(h, {
    type: "warning",
    title: geral.validacao.titulo,
    message,
    dangerouslyUseHTMLString
  });
}

export function buildErrorNotifyPayload(h, err, mensagemErroPadrao) {
  const statusWarning = [400, 422];
  if (err && statusWarning.includes(err.status)) {
    return buildValidationNotifyPayload(h, err);
  }
  const geral = getGeralMensagens();
  const fallback = mensagemErroPadrao || geral.erro.mensagem;

  return aplicarWrapMensagemNotify(h, {
    type: "error",
    title: geral.erro.titulo,
    message: (err && err.message) || fallback
  });
}
